import * as extendActionType from '../extendActionType.js';

export const REGISTER_USER = 'auth/REGISTER_USER';
export const LOGIN_FROM_REGISTER = 'auth/REGISTER_USER_FROM_LOGIN';
export const VERIFY_REGISTRATION = 'auth/VERIFY_REGISTRATION';
export const LOGIN = 'auth/LOGIN';
export const LOGIN_AS_USER = 'auth/LOGIN_AS_USER';
export const LOGIN_BY_TOKEN = 'auth/LOGIN_BY_TOKEN';
export const LOGOUT = 'auth/LOGOUT';
export const LOGOUT_BY_SERVER = 'auth/LOGOUT_BY_SERVER';
export const RESET_PASSWORD = 'auth/RESET_PASSWORD';
export const CONFIRM_RESET_PASSWORD = 'auth/CONFIRM_RESET_PASSWORD';
export const ACTIVATE_ACCOUNT = 'auth/ACTIVATE_ACCOUNT';
export const FORGOT_PASSWORD = 'auth/FORGOT_PASSWORD';
export const CHECK_RESET_TOKEN = 'auth/CHECK_RESET_TOKEN';
export const RESTORE_PASSWORD = 'auth/RESTOR_PASSWORD';
export const SEND_CHANGED_PASSWORD = 'changePassword/SEND_CHANGED_PASSWORD';
export const GET_SERVER_TIMESTAMP = 'auth/GET_SERVER_TIMESTAMP';
export const CREATE_VMA_PASSWORD = 'auth/CREATE_VMA_PASSWORD';
export const GET_PROFILE_FILLED_STATUS = 'auth/GET_PROFILE_FILLED_STATUS';
export const LOGOUT_TO_ADMIN = 'auth/LOGOUT_TO_ADMIN';
export const PATIENT_DETACHED_SOCKET = 'user:patient:detached';

export const SOCKET_LOGOUT = 'user:logout';


export function loginByToken() {
    return {
        type: LOGIN_BY_TOKEN,
        httpRequest: {
            method: 'post',
            path: '/users/loginByToken',
            noToken: true,
            data: {},
        },
    };
}

export function logoutToAdmin() {
    return {
        type: LOGOUT_TO_ADMIN,
        httpRequest: {
            method: 'del',
            path: '/users/logout/to/admin',
        },
    };
}

export function getProfileFilledStatus() {
    return {
        type: GET_PROFILE_FILLED_STATUS,
        httpRequest: {
            method: 'get',
            path: '/users/profile/filled',
        },
    };
}

export function login(fields) {
    return {
        type: LOGIN,
        httpRequest: {
            method: 'post',
            path: '/users/login',
            noToken: true,
            data: {...fields},
        },
    };
}

export function loginAsUser(userId) {
    return {
        type: LOGIN_AS_USER,
        httpRequest: {
            method: 'post',
            path: `/users/login/as/${userId}`,
            noToken: true,
        },
    };
}

export function showLogin() {
    return {type: extendActionType.show(LOGIN)};
}

export function hideLogin() {
    return {type: extendActionType.clean(LOGIN)};
}


export function logout() {
    return {
        type: LOGOUT,
        httpRequest: {
            method: 'post',
            path: '/users/logout',
            data: {},
        },
    };
}

export function showRegisterUser(dialogType) {
    return {type: extendActionType.show(REGISTER_USER), dialogType};
}

export function hideRegisterUser() {
    return {type: extendActionType.clean(REGISTER_USER)};
}

export function registerUser(fields, stateFiles) {
    const files = {};
    Object.keys(stateFiles).forEach((key) => {
        if (stateFiles[key] instanceof Blob) files[key] = stateFiles[key];
    });
    return {
        type: REGISTER_USER,
        httpRequest: {
            method: 'post',
            path: '/users',
            noToken: true,
            data: fields,
            files,
        },
    };
}

export function loginUserFromRegister(login) {
    return {
        type: LOGIN_FROM_REGISTER,
        result: {...login},
    };
}

export function verifyRegistration(verificationToken) {
    return {
        type: VERIFY_REGISTRATION,
        httpRequest: {
            method: 'post',
            path: '/users/verify',
            noToken: true,
            data: {
                token: verificationToken,
            },
        },
    };
}

export function forgotPassword(email) {
    return {
        type: FORGOT_PASSWORD,
        httpRequest: {
            method: 'post',
            path: '/users/reset/request',
            noToken: true,
            data: {email},
        },
    };
}

export function showForgotPassword() {
    return {type: extendActionType.show(FORGOT_PASSWORD)};
}

export function hideForgotPassword() {
    return {type: extendActionType.clean(FORGOT_PASSWORD)};
}


export function restorePassword(token, password) {
    return {
        type: RESTORE_PASSWORD,
        httpRequest: {
            method: 'post',
            path: `/users/reset/${token}`,
            noToken: true,
            data: {password},
        },
    };
}

export function createVmaPassword(token, password) {
    return {
        type: CREATE_VMA_PASSWORD,
        httpRequest: {
            method: 'post',
            path: `/vmas/password/${token}`,
            noToken: true,
            data: {password},
        },
    };
}

export function showCreateVmaPassword() {
    return {type: extendActionType.show(CREATE_VMA_PASSWORD)};
}

export function hideCreateVmaPassword() {
    return {type: extendActionType.clean(CREATE_VMA_PASSWORD)};
}

export function showRestorePassword() {
    return {type: extendActionType.show(RESTORE_PASSWORD)};
}

export function hideRestorePassword() {
    return {type: extendActionType.clean(RESTORE_PASSWORD)};
}

export function checkResetToken(token) {
    return {
        type: CHECK_RESET_TOKEN,
        httpRequest: {
            method: 'get',
            path: `/users/reset/${token}`,
            noToken: true,
        },
    };
}


export function getServerTimestamp() {
    return {
        type: GET_SERVER_TIMESTAMP,
        httpRequest: {
            method: 'get',
            path: '/assets/timestamp',
            noToken: true,
        },
    };
}


export function sendChangedPassword(data) {
    return {
        type: SEND_CHANGED_PASSWORD,
        httpRequest: {
            method: 'post',
            path: 'users/change-password',
            data,
        },
    };
}



// WEBPACK FOOTER //
// ./src/reducers/auth/authActions.js